/**
 * Created by xing.lin on 2019/6/28.
 */
export default {
  methods: {
    contactMe() {
      this.$vux.confirm.show({
        content:this.$t('withdrawRecord.contactMe'),
        confirmText: this.$t('instruction.readBtn'),
        showCancelButton: false
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/confirmBox.js